import * as types from './mutation-types'
import {createFormData} from "@/mixins/Helpers";

export const loadDoors = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/doors/collection', data).then((response) => {
            commit(types.LOAD_DOORS, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateDoors = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch('update/'+ data.id +'/door', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const createDoors = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('store/door', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const deleteDoors = ({ commit }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.delete('delete/' + id + '/door').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const importDoors = ({commit}, data) => {
    let formSubmit = createFormData(data)
    return new Promise((resolve, reject) => {
        window.axios.post(`import/doors`, formSubmit).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const setDoorAccessMethods = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch(`set/door/${data.door}/access-methods`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateDoorAccessMethods = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch(`update/door/${data.door}/access-methods/${data.key}`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteDoorAccessMethods = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.delete(`delete/door/${data.door}/access-methods/${data.key}`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const getDoorUserAccess = ({ commit }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`get/door/${id}/users-with-access`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const getDoorGroupAccess = ({ commit }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`get/door/${id}/groups`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const addUsersToDoorOrPerimeter = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`store/door/user/access-methods`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateUserAccessToDoor = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`update/door/user/access-methods`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}